import { requestWithAuthorization } from "../network/apiRequests";

export interface ApiKey {
  key_id: string;
  api_key: string;
  name: string;
  created_at: string;
  last_used_at: string | null;
  is_active: boolean;
  usage_count: number;
}

export interface CreateApiKeyRequest {
  name: string;
}

export interface CreateApiKeyResponse {
  api_key: string;
  key_id: string;
}

export class ApiKeysService {
  private static readonly BASE_URL = process.env.REACT_APP_API_HOSTNAME || "";

  static async getApiKeys(): Promise<ApiKey[]> {
    try {
      const response = await requestWithAuthorization(
        `${this.BASE_URL}/user/api-keys`
      );

      if (response.status === 200) {
        return response.data;
      }
      throw new Error(`Failed to fetch API keys: ${response.status}`);
    } catch (error) {
      console.error("Error fetching API keys:", error);
      throw error;
    }
  }

  static async createApiKey(name: string): Promise<CreateApiKeyResponse> {
    try {
      const response = await requestWithAuthorization(
        `${this.BASE_URL}/user/api-keys`,
        {},
        "post",
        { "name": name }
      );

      if (response.status === 201) {
        return response.data;
      }
      throw new Error(`Failed to create API key: ${response.status}`);
    } catch (error) {
      console.error("Error creating API key:", error);
      throw error;
    }
  }

  static async deleteApiKey(keyId: string): Promise<void> {
    try {
      const response = await requestWithAuthorization(
        `${this.BASE_URL}/user/api-keys/${keyId}`,
        {},
        "delete"
      );

      if (response.status !== 204) {
        throw new Error(`Failed to delete API key: ${response.status}`);
      }
    } catch (error) {
      console.error("Error deleting API key:", error);
      throw error;
    }
  }

  static maskApiKey(apiKey: string): string {
    if (!apiKey || apiKey.length < 12) {
      return apiKey;
    }
    // Show first 8 characters, mask the rest
    const prefix = apiKey.substring(0, 8);
    const suffix = apiKey.substring(apiKey.length - 4);
    const maskedLength = apiKey.length - 12;
    const mask = "*".repeat(maskedLength);
    return `${prefix}${mask}${suffix}`;
  }
}